import * as React from "react";

export type ChatMicroBtnProps = {
  title: string;
  "aria-label"?: string;
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
};

export const ChatMicroBtn: React.FC<ChatMicroBtnProps> = ({
  title,
  "aria-label": ariaLabel,
  disabled,
  onClick,
  children,
  className,
}) => (
  <button
    type="button"
    className={`chat-micro-btn${className ? ` ${className}` : ""}`}
    title={title}
    aria-label={ariaLabel ?? title}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);
